export default __webpack_public_path__ + "static/media/frame_vi_sp.eeb1b1de.png";